// extracted by mini-css-extract-plugin
export default {"CreateProviderConfigContent":"CreateProviderConfigContent_CreateProviderConfigContent__I9adv"};